import React from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  PageHeader,
  Spinner,
  DivisionInformation,
  DivisionClients,
} from '../components'


class Division extends React.Component {
  render() {
    if (this.props.data.loading) {
      return <Spinner type='tail' />
    }

    let divisionId = this.props.match.params.divisionId
    return (
      <section className='stage slds-grid slds-grid--vertical slds-nowrap'>
          <PageHeader name='Division:' />
          <div className='stage-main slds-grid slds-wrap slds-grow slds-scrollable--y' role='main'>
            <div className='slds-grow slds-size--1-of-1 slds-medium-size--1-of-1 slds-large-size--12-of-12 slds-col-rule--right padded-container'>
              <DivisionInformation divisionId={divisionId} />
              <DivisionClients divisionId={divisionId} />
            </div>
        </div>
      </section>
    )
  }
}

const getDivisionEmployer = gql`
  query($id: ID!) {
    division(id: $id) {
      id
      employer {
        id
      }
    }
  }
`

const withData =
  graphql(getDivisionEmployer, {
    options: ({ divisionId }) => ({
      variables: {
        id: divisionId
      }
    })
  })

export default withData(Division)



// WEBPACK FOOTER //
// ./src/containers/Division.js